
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    REF: "REF",
    DRW: "DRW",
    DSG: "DSG",
    DIR: "DIR",
    SCE: "SCE",
    VER: "VER",
    SRCE: "SRCE"
};
